import React, { Component } from "react";
import Project from "./Project";
import { Link } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng
} from "react-places-autocomplete";

export default class Projects extends Component {
  state = {
    ListView: true,
    ungroupedProjects: [],
    groupedProjects: [],
    goals: null,
    filters: {
      sort: "",
      goalId: "",
      location: null,
      search: ""
    },
    address: "",
    mobileFilters: false
  };

  ShowlistView = e => {
    this.setState({ ListView: true });
  };
  ShowthumbnailView = e => {
    this.setState({ ListView: false });
  };

  showFilter = (e) => {
    this.setState({
      mobileFilters: !this.state.mobileFilters
    });
  };

  handleChange = (name, e) => {
    let filters = this.state.filters;
    if (name === "location") {
      this.setState(
        { address: e },
        function() {
          this.getFilteredprojects(this);
        }.bind(this)
      );
    } else {
      filters[name] = e.target.value;
      this.setState(
        { filters },
        function() {
          this.getFilteredprojects(this);
        }.bind(this)
      );
    }
  };

  handleSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        let location = {};
        let addressObj = results[0];
        location["location"] = addressObj["formatted_address"];
        for (var i = 0; i < addressObj.address_components.length; i++) {
          var addressType = addressObj.address_components[i].types[0];
          if (addressType == "locality") {
            location["locality"] =
              addressObj.address_components[i]["long_name"];
          } else if (addressType == "administrative_area_level_1") {
            location["state"] = addressObj.address_components[i]["long_name"];
          } else if (addressType == "country") {
            location["country"] = addressObj.address_components[i]["long_name"];
          } else if (addressType == "sublocality_level_1") {
            location["sub_locality"] =
              addressObj.address_components[i]["long_name"];
          }
        }
        let filters = this.state.filters;
        filters["location"] = location;
        this.setState(
          { address: addressObj["formatted_address"], filters },
          function() {
            this.getFilteredprojects(this);
          }.bind(this)
        );
      })
      .catch(error => console.error("Error", error));
  };

  resetFilter = () => {
    let filters = {
      sort: "",
      goalId: "",
      location: null,
      search: ""
    };
    this.setState(
      { address: "", filters },
      function() {
        this.getFilteredprojects(this);
      }.bind(this)
    );
  };

  componentDidMount() {
    this.getFilteredprojects(this);
  }

  getFilteredprojects() {
    let filters = this.state.filters;
    let query = "";

    if (filters.goalId !== null && filters.goalId !== "") {
      query += "?goal=" + filters.goalId;
    }

    if (filters.search !== null && filters.search !== "") {
      if (query === "") query = "?query=" + filters.search;
      else query += "&query=" + filters.search;
    }
    if (filters.sort !== null && filters.sort !== "") {
      if (query === "") query = "?sort=" + filters.sort;
      else query += "&sort=" + filters.sort;
    }

    if (
      filters.location !== null &&
      filters.location.hasOwnProperty("location")
    ) {
      if (query === "") query = "?location=" + filters.location.location;
      else query += "&location=" + filters.location.location;

      if (filters.location.hasOwnProperty("locality"))
        query += "&locality=" + filters.location.locality;
      if (filters.location.hasOwnProperty("sub_locality"))
        query += "&sub_locality=" + filters.location.sub_locality;
      if (filters.location.hasOwnProperty("state"))
        query += "&state=" + filters.location.state;
      if (filters.location.hasOwnProperty("country"))
        query += "&country=" + filters.location.country;
    }

    fetch(process.env.REACT_APP_LE_API_URL + "projectsearch" + query)
      .then(response => response.json())
      .then(data => {
        let projects = [];
        let goals = [],
          goalIds = [];
        for (let i = 0; i < data.data.grouped.length; i++) {
          for (let j = 0; j < data.data.grouped[i].projects.length; j++) {
            projects.push(data.data.grouped[i].projects[j]);
            if (
              goalIds.indexOf(data.data.grouped[i].projects[j].goalId) == -1
            ) {
              let goal = {};
              goal["id"] = data.data.grouped[i].projects[j].goalId;
              goal["name"] = data.data.grouped[i].projects[j].goaltitle;
              goals.push(goal);
              goalIds.push(data.data.grouped[i].projects[j].goalId);
            }
          }
        }

        for (let j = 0; j < data.data.ungrouped.length; j++) {
          if (goalIds.indexOf(data.data.ungrouped[j].goalId) == -1) {
            let goal = {};
            goal["id"] = data.data.ungrouped[j].goalId;
            goal["name"] = data.data.ungrouped[j].goaltitle;
            goals.push(goal);
            goalIds.push(data.data.ungrouped[j].goalId);
          }
        }

        if (this.state.goals === null) {
          this.setState({
            ungroupedProjects: data.data.ungrouped,
            groupedProjects: projects,
            goals
          });
        } else {
          this.setState({
            ungroupedProjects: data.data.ungrouped,
            groupedProjects: projects
          });
        }
      });
  }

  render() {
    const { ungroupedProjects, groupedProjects, goals, filters } = this.state;
    if (ungroupedProjects !== undefined) {
      return (
        <React.Fragment>
          <div className="container d-flex justify-content-between align-items-center px-4  mb-2">
            <Link to="/" className="back-home-link">
              <i className="fas fa-chevron-left mr-2" />
              Home
            </Link>
            <h3 className="my-4 projects-header">
              Select your Project &amp; start Building your{" "}
              <span className="highlight">Legacy</span>.
            </h3>
            <div className="toggle-icons d-flex">
              <i
                className="fas fa-th-list mr-3 toggle-icon"
                onClick={this.ShowlistView}
              />
              <i
                className="fas fa-th-large toggle-icon"
                onClick={this.ShowthumbnailView}
              />
            </div>
          </div>
          <div className="container d-flex align-items-center showMobileFilter mb-3" onClick={this.showFilter}>
            <hr className="filterHr" />
            Filter Projects
            <i class="fas fa-sort-down"  />
          </div>

          <div className="container d-flex justify-content-between align-items-center px-4  mb-3 filterLaptop">
            <div className="col goalsFilter">
              <select
                required
                className="form-control"
                value={filters.goalId}
                onChange={this.handleChange.bind(this, "goalId")}
              >
                <option value="" disabled>
                  Select Project Goals
                </option>
                {this.state.goals !== null
                  ? goals.map((goal, index) => (
                      <option value={goal.id} key={index}>
                        {goal.name}
                      </option>
                    ))
                  : null}
              </select>
            </div>

            <div className="col">
              <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange.bind(this, "location")}
                onSelect={this.handleSelect.bind(this)}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading
                }) => (
                  <div className='location'>
                    <input
                      {...getInputProps({
                        placeholder: "Search Places ...",
                        className: "location-search-input form-control"
                      })}
                    />
                    <div className="autocomplete-dropdown-container">
                      {loading && <div>Loading...</div>}
                      {suggestions.map(suggestion => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? { backgroundColor: "#fafafa", cursor: "pointer" }
                          : { backgroundColor: "#ffffff", cursor: "pointer" };
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </div>

            <div className="col projectSort">
              <select
                required
                className="form-control"
                value={filters.sort}
                onChange={this.handleChange.bind(this, "sort")}
              >
                <option value="" disabled>
                  Sort By
                </option>
                <option value="latest">Latest</option>
                <option value="ending_soon">Ending Soon</option>
                <option value="most_funded">Most Funded</option>
              </select>
            </div>

            <div className="col searchFilter">
              <input
                className="form-control"
                type="text"
                value={this.state.search}
                placeholder="Search Keywords"
                onChange={this.handleChange.bind(this, "search")}
              />
            </div>

            <div className="col reset">
              <button
                className=" btn resetbtn"
                type="button"
                onClick={this.resetFilter}
              >
                Reset
              </button>
            </div>
          </div>

          {this.state.mobileFilters? (
            <div className="container justify-content-between align-items-center px-4  mb-3 filterMobile">
            <div className="goalsFilter mb-2">
              <select
                required
                className="form-control"
                value={filters.goalId}
                onChange={this.handleChange.bind(this, "goalId")}
              >
                <option value="" disabled>
                  Select Project Goals
                </option>
                {this.state.goals !== null
                  ? goals.map((goal, index) => (
                      <option value={goal.id} key={index}>
                        {goal.name}
                      </option>
                    ))
                  : null}
              </select>
            </div>

            <div className="mb-2">
              <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange.bind(this, "location")}
                onSelect={this.handleSelect.bind(this)}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading
                }) => (
                  <div className='location'>
                    <input
                      {...getInputProps({
                        placeholder: "Search Places ...",
                        className: "location-search-input form-control"
                      })}
                    />
                    <div className="autocomplete-dropdown-container">
                      {loading && <div>Loading...</div>}
                      {suggestions.map(suggestion => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? { backgroundColor: "#fafafa", cursor: "pointer" }
                          : { backgroundColor: "#ffffff", cursor: "pointer" };
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </div>

            <div className="projectSort mb-2">
              <select
                required
                className="form-control"
                value={filters.sort}
                onChange={this.handleChange.bind(this, "sort")}
              >
                <option value="" disabled>
                  Sort By
                </option>
                <option value="latest">Latest</option>
                <option value="ending_soon">Ending Soon</option>
                <option value="most_funded">Most Funded</option>
              </select>
            </div>

            <div className="searchFilter mb-2">
              <input
                className="form-control"
                type="text"
                value={this.state.search}
                placeholder="Search Keywords"
                onChange={this.handleChange.bind(this, "search")}
              />
            </div>

            <div className="reset">
              <button
                className=" btn resetbtn"
                type="button"
                onClick={this.resetFilter}
              >
                Reset
              </button>
            </div>
          </div>
          ) : null}

          

          <div className="d-flex flex-wrap">
            {ungroupedProjects.map(project => (
              <Project
                key={project.id}
                project={project}
                listview={this.state.ListView}
              />
            ))}
            {groupedProjects.map(project => (
              <Project
                key={project.id}
                project={project}
                listview={this.state.ListView}
              />
            ))}
          </div>
        </React.Fragment>
      );
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/Projects.js